import { useState } from "react";

// Import images
import w7_18 from "../assets/w7_18.jpg";
import w7_19 from "../assets/w7_19.jpg";
import w7_20 from "../assets/w7_20.jpg";
import w7_21 from "../assets/w7_21.jpg";
import w7_22 from "../assets/w7_22.jpg";
import w7_23 from "../assets/w7_23.jpg";
import w7_24 from "../assets/w7_24.jpg";
import w7_25 from "../assets/w7_25.jpg";
import w7_26 from "../assets/w7_26.jpg";
import w7_27 from "../assets/w7_27.jpg";
import w7_28 from "../assets/w7_28.jpg";
import nc from "../assets/nc.jpg";


// Array of slides with alternating text and images
const slides = [
    { type: "text", title: "CAM Process", description: "Enter Manufacture Mode" },
    { type: "image", src: w7_18 },
  
    { type: "text", title: "Generate a new Setup", description: "" },
    { type: "image", src: w7_19 },
  
    { type: "text", title: "Configure Work Coordinate System", description: "" },
    { type: "image", src: w7_20 },
  
    { type: "text", title: "Use the Drill-Tool", description: "Mark the Checkbox Select Same Diameter" },
    { type: "image", src: w7_21 },
  
    { type: "text", title: "Settings for the Drill", description: "Set Clearance Height Offset to 5mm and Bottom Height Offset to -0.5mm" },
    { type: "image", src: w7_22 },
  
    { type: "text", title: "2D Contour", description: "Set Clearance Height Offset to 5mm and Bottom Height Offset to -0.3mm" },
    { type: "image", src: w7_23 },
  
    { type: "text", title: "Bottom Height", description: "Select Model bottom as Bottom Height" },
    { type: "image", src: w7_24 },
  
    { type: "text", title: "Add Tabs", description: "Add Tabs - we tested 8mm Tab Width, 2.3mm Tab Height and 75mm Tab Distance" },
    { type: "image", src: w7_26 },
  
    { type: "text", title: "Simulation", description: "After each Part of the setup execute a simulation to see, if problems occur " },
    { type: "image", src: w7_27 },

    { type: "image", src: w7_28 },
    { type: "text", title: "Generating the NC Program", description: "" },
    { type: "image", src: nc,}
  ];
  

export default function ExplanatoryGallery2() {
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? slides.length - 1 : prevIndex - 1
    );
  };

  return (
    <div className="max-w-[800px] mx-auto mt-10">
      {/* Slide Content: Either Text or Image */}
      {slides[currentIndex].type === "text" ? (
        <div className="bg-gray-100 p-6 rounded-lg shadow-md flex items-center justify-center text-center w-full h-[400px]">
          <div>
            <h2 className="text-xl font-semibold mb-2">{slides[currentIndex].title}</h2>
            <p className="text-gray-600">{slides[currentIndex].description}</p>
          </div>
        </div>
      ) : (
        <div className="relative w-full h-[400px]">
          <img
            src={slides[currentIndex].src}
            alt={`Slide ${currentIndex + 1}`}
            className="rounded-lg shadow-lg w-full h-full object-contain"
          />
        </div>
      )}

      {/* Navigation Buttons */}
      <div className="flex justify-between mt-4">
        <button
          onClick={prevSlide}
          className="bg-gray-800 text-white px-4 py-2 rounded-lg hover:bg-gray-700"
        >
          ◀ Previous
        </button>
        <button
          onClick={nextSlide}
          className="bg-gray-800 text-white px-4 py-2 rounded-lg hover:bg-gray-700"
        >
          Next ▶
        </button>
      </div>

      {/* Indicator Dots */}
      <div className="flex justify-center mt-4 space-x-2">
        {slides.map((_, index) => (
          <div
            key={index}
            className={`w-3 h-3 rounded-full ${
              index === currentIndex ? "bg-gray-800" : "bg-gray-400"
            }`}
          ></div>
        ))}
      </div>
    </div>
  );
}
